/**
 * The responsibility of this file is to manage the state of the selected menu in the event dashboard.
 * At a time only one menu can be selected.
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedMenu: 'eventDashboard' // Track the currently selected menu
};

const eventDashboardMenListSlice = createSlice({
    name: 'eventDashboardMenuList',
    initialState,
    reducers: {
        selectMenu: (state, action) => {
            state.selectedMenu = action.payload; // Update the selected menu
        }
    }
});

export default eventDashboardMenListSlice.reducer;

export const { selectMenu } = eventDashboardMenListSlice.actions;
